import { useProfile } from "@/context/useProfileProps";
import { useRef, useState } from "react";

import ProfileModal from "@/components/common/profileModal";
import { delRefType } from "@/components/profile/types";

import EducationFields from "./components/EducationFields";
import { EditProps, EducationLoadingTypes } from "./types";

const EditCard = ({
  isEdit,
  closeEdit,
  prefilledData,
  isCalledFromOutside = false,
  formRef,
  handleFooterBtnLoading,
}: EditProps) => {
  const [loading, setLoading] = useState({
    isSaveLoading: false,
    isDeleteLoading: false,
  });
  const educationPrefillId = prefilledData?.educationPrefillData?.id;
  const isAutoUpdated = prefilledData?.educationPrefillData?.isAutoUpdated;
  const delRef = useRef<delRefType>(null);
  const {
    isMobile,
    translation: { education },
  } = useProfile();

  const handleLoading = (e: EducationLoadingTypes) => {
    setLoading((prev) => ({ ...prev, ...e }));
    if (e.isSaveLoading !== undefined && handleFooterBtnLoading) {
      handleFooterBtnLoading({ isSaveLoading: e.isSaveLoading });
    }
  };

  const renderForm = (
    <EducationFields
      handleLoading={handleLoading}
      prefilledData={prefilledData}
      closeEdit={closeEdit}
      formRef={formRef}
      delRef={delRef}
    />
  );

  return !isCalledFromOutside ? (
    <ProfileModal
      id="education-edit-modal"
      heading={
        isAutoUpdated
          ? education.editEducation
          : educationPrefillId
            ? education.editEducation
            : education.addEducation
      }
      showModal={isEdit}
      closeModal={closeEdit}
      isMobile={isMobile}
      showCloseButton={true}
      screenAlignment={isMobile ? "bottom-sheet" : "center"}
      showHandleBar={isMobile}
      footerPrimaryBtnLabel="Save"
      footerPrimaryBtnHandler={() => formRef.current?.requestSubmit()}
      footerSecondaryBtnLabel={
        educationPrefillId && !isAutoUpdated ? "Delete Education" : ""
      }
      footerSecondaryBtnHandler={() => delRef.current?.handleDelete()}
      footerPrimaryBtnIsLoading={loading.isSaveLoading}
      footerSecondaryBtnIsLoading={loading.isDeleteLoading}
    >
      {renderForm}
    </ProfileModal>
  ) : (
    renderForm
  );
};

export default EditCard;
